import React from 'react';
import PropTypes from 'prop-types';
import {Button, Col, Row} from 'react-bootstrap';

import AssetService from "../../services/AssetService";
import {dayMonthYearAtTime} from "../../utils/dates";
import Box from "../Box/Box";
import Notify from "../../services/Notify";
import Loading from "../Loading/Loading";
import AssetGallery from "./gallery/AssetGallery";
import AssetAuditingService from "../../services/AssetAuditingService";
import CompanyConfigurationService from "../../services/CompanyConfiguration";
import BarcodeByCompany from './barcode/BarcodeByCompany';
import SerialByCompany from './serial/SerialByCompany';
import {Link} from "react-router-dom";
import BarcodePatternIdentifierService from "./barcode/BarcodePatternIdentifier";

class AssetDetail extends React.Component {

  service = new AssetService();
  assetAuditingService = new AssetAuditingService();
  companyConfigurationService = new CompanyConfigurationService();

  constructor(props) {
    super(props);
    this.state = {epc: props.epc};
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.epc !== nextProps.epc) {
      this.findAsset(nextProps.epc);
    }
  }

  componentWillMount() {
    const {epc} = this.props;
    this.findAsset(epc);
  }

  findAsset(epc) {
    this.setState({loading: true, message: null});
    this.service.findByEpc(epc).then(
      data => {
        let barcodeData = {};
        try {
          if (data.internalBarcode && data.internalBarcode.code) {
            barcodeData = BarcodePatternIdentifierService.identify(data.internalBarcode.code);
          }
        } catch (e) {}
        this.setState(
          {
            asset: data,
            barcodeData,
            dateByEpc: BarcodePatternIdentifierService.getDateByBarcodeEpc(
              data.internalBarcode && data.internalBarcode.code, data.epc.value)
          });
        this.findAssetAuditing(this.state.asset.id);
      },
      error => {
        const state = {loading: false, asset: null};
        if (error.response.status === 404) {
          state.message = 'Entidade não encontrada!';
        } else {
          state.message = 'Erro inesperado!';
          Notify.error('Falha o buscar entidade!', error)
        }
        this.setState(state);
      }
    )
  }

  findAssetAuditing(assetId) {
    this.assetAuditingService.getAssetAuditingById(assetId).then(
      data => this.setState(
        {
          loading: false,
          assetAuditing: data
        }
      ),
      error => {
        if (error.response.status === 404) {
          this.setState(
            {
              loading: false,
              assetAuditing: null
            });
        } else {
          Notify.error('Falha o buscar entidade!', error)
        }
      }
    )
  }

  render() {
    const {asset, loading, message, assetAuditing, dateByEpc, barcodeData = {}} = this.state;

    if (loading) {
      return <Loading/>
    }

    if (message) {
      return message;
    }

    const EPCsToShow = asset.tags.map(tag => {
      return (
        <li>{tag.value}</li>
      )
    })

    const manufactureDate =
      (dateByEpc && dateByEpc.manufactureDate) ||
      (asset.lot && asset.lot.manufactureDate);

    return (
      <Box title='Detalhes do produto'>
        <Row>
          <Col md={8}>
            <AssetGallery asset={asset}/>
          </Col>
          <Col md={4}>
            <Button className="pull-right" bsStyle="primary" href={`/#/audit/${asset.epc && asset.epc.value}`}>Auditar</Button>
            <Link to={{
              pathname: '/transactions/new',
              aboutProps: {
                listAssetsChecked: [this.state.asset],
              }
            }}>
              <button className="btn btn-primary pull-right">
                Mover Produto
              </button>
            </Link>
          </Col>
        </Row>
        <ul className="list-group list-group-unbordered product-detail">

          <li className="list-group-item">
            <b>Produto</b>:
            <h2>{asset.productType.reference}</h2>
            <h2>{asset.productType.friendlyName}</h2>
          </li>

          <li className="list-group-item">
            <b>EPCs</b>:
            <li>
              {
                EPCsToShow
              }
            </li>
          </li>

          <BarcodeByCompany asset={asset}/>
          <SerialByCompany asset={asset}/>

          {asset.barcode !== null &&
            <li className="list-group-item">
              <b>Código EAN</b>: {asset.barcode.code}
            </li>
          }

          {asset.tagId !== null &&
            <li className="list-group-item">
              <b>TagId</b>: {asset.tagId}
            </li>
          }

          {asset.productType.manufacturer !== null &&
            <li className="list-group-item">
              <b>Fabricante</b>: {asset.productType.manufacturer}
            </li>
          }
          <li className="list-group-item">
            <b>Data de criação no sistema</b>: {dayMonthYearAtTime(asset.createdAt)}
          </li>
          {manufactureDate && !barcodeData.manufactureDate &&
            <li className="list-group-item">
              <b>Data de fabricação do lote</b>: {manufactureDate}
            </li>
          }
           {asset.tagId !== null &&
            <li className="list-group-item">
              <b>Unidade de Medida</b>: {asset.productType.unitType}
            </li>
          }
          {asset.lot !== null && !barcodeData.lot &&
            <li className="list-group-item">
              <b>Lote</b>: {asset.lot.code}
            </li>
          }
          {
            this.companyConfigurationService.canShowWeight() &&
            asset.weightInKg !== null &&
            <li className="list-group-item">
              <b>Peso</b>: {`${asset.weightInKg
              ? (asset.weightInKg.toString().replace('.', ',')) : 0} kg`}
            </li>
          }
          {assetAuditing && assetAuditing.userCreatedBy !== null &&
            <li className="list-group-item">
              <b>Usuário Auditor</b>: {assetAuditing.userCreatedBy.name}
            </li>
          }
          {assetAuditing && assetAuditing.userCreatedBy !== null &&
            <li className="list-group-item">
              <b>Data da auditoria</b>: {dayMonthYearAtTime(assetAuditing.createdAt)}
            </li>
          }
        </ul>
      </Box>)
  };
}

AssetDetail.propTypes = {
  asset: PropTypes.object,
  tagId: PropTypes.string
};

export default AssetDetail;



// WEBPACK FOOTER //
// ./src/component/Asset/AssetDetail.js